export const getUserId = userId => (userId == null ? 'guest' : userId)
